import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight, MapPin } from "lucide-react";
import Seo, { BreadcrumbJsonLd } from "@/components/common/Seo";
import { Reveal } from "@/components/common/Reveal";

const PROJECTS = [
  { img: "/gallery/img_6326.webp", title: "GMC AT4 Rear Cabin Detail", area: "Ottawa", cat: "Interior" },
  { img: "/gallery/img_6329.webp", title: "AT4 Cockpit Deep Clean", area: "Ottawa", cat: "Interior" },
  { img: "/gallery/img_6332.webp", title: "AT4 Rear Seat Restoration", area: "Ottawa", cat: "Interior" },
  { img: "/gallery/img_6336.webp", title: "AT4 Front Seat Refresh", area: "Ottawa", cat: "Interior" },
  { img: "/gallery/img_6337.webp", title: "AT4 Dash & Console Detail", area: "Ottawa", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/bbred6iu_IMG_0318.MOV", img: "/gallery/poster_0318.jpg", title: "Mobile Wash In Action", area: "Ottawa", cat: "Wash & Wheels" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/s1w4m5d7_IMG_0319.MOV", img: "/gallery/poster_0319.jpg", title: "The Reverence Crew At Work", area: "Ottawa", cat: "Wash & Wheels" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/jw8n4skr_IMG_6373.MOV", img: "/gallery/poster_6373.jpg", title: "GMC Exterior Detail Clip", area: "Ottawa", cat: "Exterior" },
  { img: "/gallery/img_6291.webp", title: "GMC Mobile Hand Wash", area: "Ottawa", cat: "Wash & Wheels" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/xrjy89ia_IMG_6749.MOV", img: "/gallery/poster_6749.jpg", title: "Urus Interior Detail Clip", area: "Rockcliffe Park", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/smd8adhv_IMG_6750.MOV", img: "/gallery/poster_6750.jpg", title: "Urus Cabin Finish Reveal", area: "Rockcliffe Park", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/836nxnf5_IMG_6734.MOV", img: "/gallery/poster_6734.jpg", title: "Lamborghini Urus Walkaround", area: "Rockcliffe Park", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/godbnhqi_IMG_6733.MOV", img: "/gallery/poster_6733.jpg", title: "Lamborghini Urus Interior Reveal", area: "Rockcliffe Park", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/jqsc99l3_BDDFFD04-9868-4CC1-8511-7F9938F7D199.MP4", img: "/gallery/poster_bdd.jpg", title: "Urus Cabin Walkthrough", area: "Rockcliffe Park", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/htg5h33h_6FA8378E-5D72-4130-9163-B828B4EBAA5F.MP4", img: "/gallery/poster_6fa.jpg", title: "Urus Detail In Motion", area: "Rockcliffe Park", cat: "Interior" },
  { img: "/gallery/img_6729.webp", title: "Lamborghini Urus Cockpit Detail", area: "Rockcliffe Park", cat: "Interior" },
  { img: "/gallery/img_6731.webp", title: "Urus Front Seat Restoration", area: "Rockcliffe Park", cat: "Interior" },
  { img: "/gallery/img_6707.webp", title: "Lamborghini Urus Cockpit", area: "Downtown Ottawa", cat: "Interior" },
  { img: "/gallery/img_6712.webp", title: "Urus Seat Detail", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_6713.webp", title: "Supercar Interior Detail", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_6715.webp", title: "Urus Floor Mat Clean", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_6725.webp", title: "Exotic Cabin Restoration", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_6753.webp", title: "Venza Cabin Refresh", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_6757.webp", title: "Winter Salt Footwell Clean", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_6762.webp", title: "Light Leather Restoration", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_6778.webp", title: "Rear Bench Deep Clean", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_6781.webp", title: "Full Interior Transformation", area: "Gatineau", cat: "Interior" },
  { img: "/gallery/img_6862.webp", title: "Audi Rear Seat Rescue", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_6866.webp", title: "Driver Footwell Deep Clean", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_6880.webp", title: "Salt & Debris Removal", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_6882.webp", title: "Full Cabin Restoration", area: "Stittsville", cat: "Interior" },
  { img: "/gallery/img_7038.webp", title: "Cayenne Platinum Gloss", area: "Downtown Ottawa", cat: "Exterior" },
  { img: "/gallery/img_7040.webp", title: "Black Porsche Shine", area: "Nepean", cat: "Exterior" },
  { img: "/gallery/img_7034.webp", title: "Porsche Interior Detail", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_7035.webp", title: "Platinum Edition Cockpit", area: "Orleans", cat: "Interior" },
  { video: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/gcly03gb_IMG_7037.MOV", img: "/gallery/img_7038.webp", title: "Porsche Cayenne Walkaround", area: "Downtown Ottawa", cat: "Exterior" },
  { img: "/gallery/img_7024.webp", title: "Porsche Leather Detail", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_7025.webp", title: "Rear Cabin Deep Clean", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_7030.webp", title: "Cockpit Restoration", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_7031.webp", title: "Full Interior Reset", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_7051.webp", title: "Genesis Front-End Gloss", area: "Downtown Ottawa", cat: "Exterior" },
  { img: "/gallery/img_7053.webp", title: "Genesis Cockpit Detail", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_7054.webp", title: "Driver's Seat Deep Clean", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_7062.webp", title: "Dash & Console Detail", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_7063.webp", title: "Sport Interior Refresh", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_7180.webp", title: "Driver's Cabin Detail", area: "Orleans", cat: "Interior" },
  { img: "/gallery/img_7181.webp", title: "Floor Mat Deep Clean", area: "Barrhaven", cat: "Interior" },
  { img: "/gallery/img_7182.webp", title: "Salt & Grime Removal", area: "Nepean", cat: "Interior" },
  { img: "/gallery/img_7183.webp", title: "Front Seat Refresh", area: "Kanata", cat: "Interior" },
  { img: "/gallery/img_7279.webp", title: "Ceramic Showroom Finish", area: "Downtown Ottawa", cat: "Ceramic" },
  { img: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/9twz4z59_IMG_7261.webp", title: "Audi TT Cockpit Detail", area: "Kanata", cat: "Interior" },
  { img: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/6q7rw8fe_IMG_7264.webp", title: "Leather & Dash Revival", area: "Nepean", cat: "Interior" },
  { img: "https://customer-assets-eiarnc6j.emergentagent.net/job_luster-launch/artifacts/w5hij7gq_IMG_7273.webp", title: "Sports Cockpit Refresh", area: "Barrhaven", cat: "Interior" },
];

const CATS = ["All", "Exterior", "Interior", "Ceramic", "Wash & Wheels"];

export default function Gallery() {
  const [cat, setCat] = useState("All");
  const [active, setActive] = useState(null);
  const shown = cat === "All" ? PROJECTS : PROJECTS.filter((p) => p.cat === cat);

  return (
    <div data-testid="gallery-page">
      <Seo
        title="See Our Work — Detailing Gallery | Reverence Autos"
        description="Browse real mobile car detailing projects from the Reverence Autos crew across Ottawa — interior, exterior, ceramic coating and wheel work. See the showroom shine for yourself."
        path="/gallery"
      />
      <BreadcrumbJsonLd items={[{ name: "Home", path: "/" }, { name: "See Our Work", path: "/gallery" }]} />

      <section className="bg-brand-offwhite">
        <div className="container-rv py-20 text-center lg:py-28">
          <Reveal>
            <p className="overline text-brand-red">See Our Work</p>
            <h1 className="mx-auto mt-4 max-w-3xl font-serif text-5xl font-bold leading-tight text-brand-charcoal sm:text-6xl">
              The proof is in the shine
            </h1>
            <p className="mx-auto mt-5 max-w-xl text-brand-muted">
              A scroll through real cars we've transformed across Ottawa. Every one left its owner falling in love all over again.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white">
        <div className="container-rv py-14 lg:py-20">
          {/* filters */}
          <div className="mb-10 flex flex-wrap justify-center gap-3">
            {CATS.map((c) => (
              <button key={c} data-testid={`gallery-filter-${c.replace(/\s|&/g, "").toLowerCase()}`} onClick={() => setCat(c)}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${cat === c ? "bg-brand-red text-white" : "border border-brand-silver/50 text-brand-muted hover:text-brand-charcoal"}`}>
                {c}
              </button>
            ))}
          </div>

          {/* masonry */}
          <div className="columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
            {shown.map((p, i) => (
              <motion.button
                key={p.title + i}
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
                onClick={() => setActive(p)}
                data-testid={`gallery-item-${i}`}
                className="group relative block w-full overflow-hidden rounded-2xl border border-brand-silver/40 text-left"
              >
                {p.video ? (
                  <>
                    <video src={p.video} poster={p.img} muted loop playsInline autoPlay preload="metadata"
                      className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    <span className="absolute right-3 top-3 rounded-full bg-brand-red px-2.5 py-1 text-[0.6rem] font-semibold uppercase tracking-wider text-white">▶ Video</span>
                  </>
                ) : (
                  <img src={p.img} alt={`${p.title} — car detailing in ${p.area}, Ottawa`} loading="lazy"
                    className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/80 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="absolute inset-x-0 bottom-0 translate-y-2 p-5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <p className="font-serif text-lg font-bold text-white">{p.title}</p>
                  <p className="flex items-center gap-1 text-xs text-white/80"><MapPin className="h-3 w-3" /> {p.area} · {p.cat}</p>
                </div>
              </motion.button>
            ))}
          </div>

          <Reveal className="mt-16 rounded-2xl bg-brand-charcoal p-10 text-center text-white">
            <h3 className="font-serif text-3xl font-bold">Your car could be next.</h3>
            <p className="mt-2 text-brand-silver">Book your mobile detail and join the gallery.</p>
            <Link to="/book" className="btn-red mt-6" data-testid="gallery-cta-book">Book your detail <ArrowRight className="h-4 w-4" /></Link>
          </Reveal>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            data-testid="gallery-lightbox"
            className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-charcoal/90 p-6 backdrop-blur-sm"
          >
            <button data-testid="lightbox-close" className="absolute right-6 top-6 grid h-11 w-11 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20"><X className="h-5 w-5" /></button>
            <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }} onClick={(e) => e.stopPropagation()}
              className="max-h-[85vh] max-w-3xl overflow-hidden rounded-2xl">
              {active.video ? (
                <video src={active.video} poster={active.img} controls autoPlay playsInline className="max-h-[75vh] w-full bg-black object-contain" />
              ) : (
                <img src={active.img} alt={active.title} className="max-h-[75vh] w-full object-contain" />
              )}
              <div className="bg-white p-5">
                <p className="font-serif text-xl font-bold text-brand-charcoal">{active.title}</p>
                <p className="flex items-center gap-1 text-sm text-brand-muted"><MapPin className="h-3.5 w-3.5 text-brand-red" /> {active.area} · {active.cat}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
